import "./searchInput.css";

import SearchInput from "./SearchInput";

const SearchInputHeader = ({ initValue }: { initValue?: string }): JSX.Element => {
    return (
        <div className="itemSearchHeader">
            <SearchInput initValue={initValue}></SearchInput>
        </div>
    );
};

export default SearchInputHeader;
